type ApiResource<Url extends string> = Url | `${Url}/${string}`;

type DepositResource<Url extends string> = ApiResource<Url> | `${Url}/${string}/confirm`;
type CashoutResource<Url extends string> = DepositResource<Url>;
type DepositP2PResource<Url extends string> = DepositResource<Url>;
type VerifiedDocumentsResource<Url extends string> = ApiResource<Url>;


type ApiUrls =
  CashoutResource<'/v1/cashouts'> |
  DepositResource<'/v1/deposits'> |
  DepositP2PResource<'/v1/deposits/p2p_deposits'> |
  VerifiedDocumentsResource<'/v1/verified_documents'>;

const apiUrl = (url: ApiUrls): string => (process.env.REACT_APP_API_URL || 'localhost').concat(url);

export default apiUrl;
